//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { createContext } from "react";
import { GraphArgs } from "./types";

export const GraphContext = createContext<GraphArgs>({} as GraphArgs);
